import moment from "moment";

const API_HOST = process.env.REACT_APP_API_HOST_URL;

const saveFile = async (blob) => {
  const a = document.createElement("a");
  const date = moment().format("YYYYMMDD");
  a.download = `luckyDrawParticipant${date}.xlsx`;
  a.href = URL.createObjectURL(blob);
  a.addEventListener("click", (e) => {
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  });
  a.click();
};

const get = async ({ id, token }) => {
  let response = await fetch(
    `${API_HOST}/campaign/api/admin/lucky-draws/${id}/participants/excel`,
    {
      method: "Get",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  let blob = await response.blob();

  saveFile(blob);
};

const getParticipantExcel = {
  get
};

export default getParticipantExcel;
